'use client';

import { useState } from 'react';
import { PLPHeroBannerData } from './types';
import PLPHeroBannerDefault from './PLPHeroBannerDefault';
import PLPHeroBannerForward from './PLPHeroBannerForward';
import PLPHeroBannerNeedSelect from './PLPHeroBannerNeedSelect';
import OfferDetails from '../OfferCard/OfferDetails';
import type { OfferCardData } from '../OfferCard/types';

const HeroOptions: Partial<Record<PLPHeroBannerData['layout'], typeof PLPHeroBannerDefault>> = {
  'Need Select': PLPHeroBannerNeedSelect,
  Forward: PLPHeroBannerForward,
};

const PLPHeroBanner = ({ data }: { data: PLPHeroBannerData }) => {
  const [selectedOffer, setSelectedOffer] = useState<OfferCardData | null>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpen = (offer: OfferCardData) => {
    setSelectedOffer(offer);
    setIsDrawerOpen(true);
  };

  const HeroBanner = HeroOptions[data.layout] ?? PLPHeroBannerDefault;

  return (
    <>
      <HeroBanner
        data={data}
        onOpen={handleOpen}
      />
      <OfferDetails
        data={selectedOffer}
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </>
  );
};

export default PLPHeroBanner;
